import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取团队列表
export const getGroupList = params => {
    return get("/admin/team/page", params);
};
// 新增团队
export const addGroup = params => {
    return post("/admin/team/add", params);
};
// 修改团队信息
export const editGroup = params => {
    return put(`/admin/team/edit/${params.id}`, params);
};



// WEBPACK FOOTER //
// ./src/api/group.js